<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box">
      <el-menu :default-active="activeIndex" class="el-menu-demo marginB10" mode="horizontal" @select="handleSelect">
        <el-menu-item index="">全部订单</el-menu-item>
        <el-menu-item index="1">未处理</el-menu-item>
        <el-menu-item index="2">已处理</el-menu-item>
      </el-menu>
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="5">
              <el-form-item prop="date" label="下单时间">
                <DateTime v-model="searchForm.date" format='yyyy-MM-dd' style="width:100%;height:27px" type='daterange' placeholder="-请选择-" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="" label="订单来源">
                <el-input placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
                <el-button type="primary" @click="exportFile">
                  导出
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :header-cell-style="{background:'#F4F4F5'}" :data="tableData" border style="width: 100%">
        <el-table-column label="所属商铺" prop="fullName" align="center"></el-table-column>
        <el-table-column label="买家信息" prop="" align="center"></el-table-column>
        <el-table-column label="下单时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="联系单位" prop="contactUnit" align="center"></el-table-column>
        <el-table-column label="联系人" prop="contacts" align="center"></el-table-column>
        <el-table-column label="联系电话" prop="contactNumber" align="center"></el-table-column>
        <el-table-column label="需求描述" prop="describe" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="110">
          <template slot-scope="{row}">
            <el-button v-if="row.state==1" size="mini" type="primary" @click="confirm(row.id)">确认处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import DateTime from '@/components/DateTime'
export default {
  name: 'CustomizedPurchase',
  components: {
    Pagination,
    DateTime
  },
  data() {
    return {
      searchForm: {
        date: null,
        beginTime: null, //下单开始时间
        endTime: null, //下单结束时间
      
      },//查询条件
      tableData: [],//表格参数
      activeIndex: '',
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$CustomizedPurchase.pageList(
        {
          ...this.searchForm,
          state: this.activeIndex,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //切换
    handleSelect(e) {
      this.activeIndex = e;
      this.getInfo()
    },
    //确认发货
    confirm(id) {
      if (id) {
        this.$CustomizedPurchase.handleDemand({ id }).then(({ data }) => {
          if (data.code === 200) {
            this.messages(data.message, true, 1000)
            this.getInfo()
          }
        })
      }
    },
    //导出文件
    exportFile() {
      let { beginTime, endTime, merchantId, state } = this.searchForm
      this.$OrderLIst.orderExport({
        beginTime,
        endTime,
        merchantId,
        state
      }).then((response) => {
        //通过a标签下载
        let url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        console.log(decodeURI(response.headers['content-disposition'].split(';')[1].replace('filename=', '')), 'rrrewwwrssede')
        link.download = decodeURI(response.headers['content-disposition'].split(';')[1].replace('filename=', '')); //获取文件名
        document.body.appendChild(link);
        link.click()
        URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
.table {
  width: 100%;
  .table_heder {
    display: flex;
    box-sizing: border-box;
    height: 48px;
    background: #f8f8fe;
    border: 1px solid #eeeeee;
    margin-bottom: 12px;
    > div {
      width: 100px;
      height: 48px;
      line-height: 48px;
      text-align: center;
    }
  }
  .table_content {
    .info_box {
      width: 100%;
      height: 30px;
      background: #f4f4f4;
      display: flex;
      > span {
        width: 250px;
        font-size: 12px;
        line-height: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #222222;
      }
    }
    .content_box {
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      display: flex;
      > div {
        width: 100px;
        min-height: 48px;
        text-align: center;
      }
    }
  }
}
.flex_shrink {
  flex-shrink: 1;
}
.LR_border {
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
.info_b {
  display: flex;
  box-sizing: border-box;
  height: 88px;
  align-items: center;
  > img {
    width: 55px;
    height: 55px;
  }
  .details_box {
    margin-left: 20px;
    width: 200px;
    display: flex;
    flex-direction: column;
    > span {
      width: 100%;
      text-align: left;
    }
    > div {
      width: 100%;
      display: flex;
      .describe {
        text-align: left;
        width: 100px;
      }
    }
  }
}
.flex_c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
